import { configureStore } from '@reduxjs/toolkit';
import alertsReducer from './alertsSlice';
import aboutPremiumReducer from './aboutPremiumSlice';
import homeReducer from './homeSlice';
import newsReducer from './newsSlice';
import faqReducer from './faqSlice';
import documentLibraryReducer from './documentLibrarySlice';
import contactPremiumReducer from './contactPremiumSlice';
import designationOverviewReducer from './designationOverviewSlice';
import userAccessReducer from './userAccessSlice';
import commCenterReducer from './commCenterSlice';
import pixeModalReducer from './pixeModalSlice';
import userReducer from './userSlice';
import accessReducer from './accessSlice';
import resultsByPhysicianReducer from './resultsByPhysicianSlice'; 
import resultsBySpecialtyReducer from './resultsBySpecialtySlice';
import reportsReducer from './reportsSlice';
import costPatientReducer from './costPatientSlice';
import caseReducer from './caseSlice';
import costReducer from './costSlice';
import qualityReducer from './qualitySlice';
import errorReducer from './errorSlice';
import profileReducer from './profileSlice';
import tagsReducer from './tagsSlice';
import dashboardReducer from './dashboardSlice';

const store = configureStore({
  reducer: {
    alerts: alertsReducer,
    aboutPremium: aboutPremiumReducer,
    designationOverview: designationOverviewReducer,
    faq: faqReducer,
    documentLibrary: documentLibraryReducer,
    contactPremium: contactPremiumReducer,
    home: homeReducer,
    news: newsReducer,
    userAccess: userAccessReducer,
    commCenter: commCenterReducer,
    pixeModal: pixeModalReducer,
    user: userReducer,     // Basic user data
    access: accessReducer,
    costPatient: costPatientReducer,
    quality: qualityReducer,
    case: caseReducer,
    cost: costReducer,  // Full user data with access control
    resultsByPhysician: resultsByPhysicianReducer, // Add the reducer
    resultsBySpecialty: resultsBySpecialtyReducer, // Add the reducer
    groupSummaryReports: reportsReducer, // Add the reducer for reports
    error: errorReducer,
    profile: profileReducer,
    tags: tagsReducer,
    dashboard: dashboardReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;